
import { Component, Prop, Vue } from "vue-property-decorator";
import Directory from "./components/knowledgeDirectory.vue";
import {
  addCollection,
  addGroup,
  batchDeleteResources,
  batchReallyDelete,
  delCollection,
  delDocument,
  delScource,
  getKnowledgeDraftsList,
  getKnowledgeRecycleListList,
  getKnowledgeScourceList,
  importScource,
  reallyDelete,
  recover,
  renameResources,
} from "@/api/knowledge";
import { UserModule } from "@/store/modules/user";
import TemplateAddedProgress from "../template/TemplateAddedProgress.vue";
import { Qiniu } from "@/types/qiniu";
import { getQiniuToken } from "@/api/third";
import { makeKey } from "@/utils/qiniu";

@Component({
  name: "KnowledgeBase",
  components: {
    Directory,
    TemplateAddedProgress,
  },
})
export default class extends Vue {
  // 页面参数定义
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0,
  };
  private winheight = window.innerHeight - 95;
  private tableData = [];
  private isSelectedMenu: any = "";

  // 骑牛
  private qiuniuToken: any = {
    action_url: "",
  };
  private qiuniuform: any = {};

  private multipleSelected = [];
  private loading = false;
  private clickType = 0;

  private pid = "0";
  private pids: any = [];

  private expandData = {};
  private refData: any = {};

  private breadcrumbTitle = "知识空间";

  handleSelectionChange(val: any) {
    this.multipleSelected = val;
  }

  created() {
    this.getKnowledgeScourceList("0");
    let params = {
      type: Qiniu.UPLOAD_TYPE_KNOWLEDGE,
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiuniuToken = res.data;
      }
    });
  }
  private getKnowledgeScourceList(isCollectionList: string) {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      name: this.inputSearch,
      is_collection: 1,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      is_collection_list: isCollectionList,
    };
    if (this.clickType === 3) {
      params.click_type = "3";
    }
    if (this.pid) {
      params.pid = this.pid;
    }
    getKnowledgeScourceList(params).then((res) => {
      if (res.data) {
        this.pids = res.data.catalogue;
      }
      if (res.data && res.data.list) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
      } else {
        this.tableData = [];
        this.pagination.total = 0;
      }
    });
  }
  private changeNode(item: any) {
    this.breadcrumbTitle = "知识空间";
    this.pagination.currentPage = 1;
    this.isSelectedMenu = "";
    this.clickType = 0;
    this.pid = item.id;
    this.getKnowledgeScourceList("0");
  }
  private allClick() {
    this.pagination.currentPage = 1;
    if (this.clickType === 3) {
      this.pid = "";
      this.getKnowledgeScourceList("1");
    } else if (this.clickType === 2) {
      this.pid = "";
      this.getKnowledgeRecycleListList();
    } else {
      this.pid = "0";
      this.getKnowledgeScourceList("0");
    }
  }
  private backUp() {
    this.pids.pop();
    this.pagination.currentPage = 1;
    if (this.pids && this.pids.length > 0) {
      this.pid = this.pids[this.pids.length - 1].id;
    } else {
      if (this.clickType === 3) {
        this.pid = "";
      } else {
        this.pid = "0";
      }
    }
    if (this.clickType === 3) {
      this.getKnowledgeScourceList("1");
    } else {
      this.getKnowledgeScourceList("0");
    }
  }
  private handleClick(type: number) {
    this.isSelectedMenu = type;
    this.pagination.currentPage = 1;
    this.clickType = type;
    this.pids = [];
    if (type === 1) {
      this.pagination.currentPage = 1;
      this.breadcrumbTitle = "草稿箱";
      this.getKnowledgeDraftsList();
    } else if (type === 2) {
      this.pagination.currentPage = 1;
      this.pid = "";
      this.breadcrumbTitle = "回收站";
      this.getKnowledgeRecycleListList();
    } else {
      this.pagination.currentPage = 1;
      this.breadcrumbTitle = "我的收藏";
      this.pid = "";
      this.getKnowledgeScourceList("1");
    }
  }
  private getKnowledgeDraftsList() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      name: this.inputSearch,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
    };
    getKnowledgeDraftsList(params).then((res) => {
      if (res.data) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
      } else {
        this.tableData = [];
        this.pagination.total = 0;
      }
    });
  }
  private getKnowledgeRecycleListList() {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      name: this.inputSearch,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
    };
    if (this.pid) {
      params.pid = this.pid;
    }
    getKnowledgeRecycleListList(params).then((res) => {
      if (res.data) {
        this.pagination.total = res.data.count;
        this.tableData = res.data.list;
      } else {
        this.tableData = [];
        this.pagination.total = 0;
      }
    });
  }
  private import(element: any) {
    let pamars: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
    };
    let fileLists = [];
    let fileData: any = {};
    fileData.name = element.raw.name;
    fileData.content = element.response.key;
    if (element.raw.type.includes("image")) {
      fileData.type = 1;
      fileLists.push(fileData);
    } else if (element.raw.type.includes("audio")) {
      fileData.type = 2;
      fileLists.push(fileData);
    } else if (element.raw.type.includes("video")) {
      fileData.type = 3;
      fileLists.push(fileData);
    } else if (element.raw.type.includes("pdf")) {
      fileData.type = 4;
      fileLists.push(fileData);
    } else if (element.raw.type.includes("sheet")) {
      fileData.type = 5;
      fileLists.push(fileData);
    } else if (element.raw.type.includes("powerpoint")) {
      fileData.type = 6;
      fileLists.push(fileData);
    } else if (element.raw.type.includes("document")) {
      if (element.raw.type.includes("presentation")) {
        fileData.type = 6;
      } else {
        fileData.type = 7;
      }
      fileLists.push(fileData);
    } else if (element.raw.type.includes("plain")) {
      fileData.type = 8;
      fileLists.push(fileData);
    } else {
      fileData.type = 90;
      fileLists.push(fileData);
    }
    pamars.pid = this.pid;
    if (fileLists.length > 0) {
      pamars.resources = JSON.stringify(fileLists);
    }
    importScource(pamars)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        this.getKnowledgeScourceList("0");
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private handleSuccess(res: any, file: any, fileList: any) {
    this.import(file);
  }
  private beforeUpload(file: any) {
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      if (file.type === "video/mp4") {
        this.$set(
          this.qiuniuform,
          "key",
          makeKey(this.qiuniuToken.prekey) + ".mp4"
        );
        this.$set(this.qiuniuform, "token", this.qiuniuToken.uptoken);
        this.$set(this.qiuniuform, "domain", this.qiuniuToken.domain);
      } else {
        this.$set(this.qiuniuform, "key", makeKey(this.qiuniuToken.prekey));
        this.$set(this.qiuniuform, "token", this.qiuniuToken.uptoken);
        this.$set(this.qiuniuform, "domain", this.qiuniuToken.domain);
      }
    });
  }
  private addDocument() {
    this.$router.push({
      path: "add",
      query: {
        pid: this.pid,
      },
    });
  }
  private groupDelete() {
    if (!this.multipleSelected || this.multipleSelected.length === 0) {
      this.showErrorMsg("请选择文件");
      return;
    }
    this.$confirm("是否批量删除?", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.batchDelete();
      })
      .catch(() => {});
  }
  private batchDelete() {
    let ids = "";
    let refId = "0";
    for (let iterator of this.multipleSelected) {
      if ((iterator as any).pid) {
        refId = (iterator as any).pid;
      }
      ids = ids + (iterator as any).id + ",";
    }
    let pamarms: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      ids: ids.substring(0, ids.length - 1),
    };
    if (this.clickType === 0) {
      batchDeleteResources(pamarms)
        .then((res: any) => {
          this.showSecussMsg(res.msg);
          this.getKnowledgeScourceList("0");
          this.refData = {
            id: refId,
            isr: !this.refData.isr,
          };
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    } else if (this.clickType === 1) {
      delDocument(pamarms)
        .then((res: any) => {
          this.showSecussMsg(res.msg);
          this.getKnowledgeDraftsList();
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    } else if (this.clickType === 2) {
      batchReallyDelete(pamarms)
        .then((res: any) => {
          this.showSecussMsg(res.msg);
          this.getKnowledgeRecycleListList();
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    }
  }

  private inputSearch = "";
  // 搜索
  handleSearch() {
    if (this.clickType === 1) {
      this.pagination.currentPage = 1;
      this.getKnowledgeDraftsList();
    } else if (this.clickType === 2) {
      this.pagination.currentPage = 1;
      this.getKnowledgeRecycleListList();
    } else if (this.clickType === 3) {
      this.pagination.currentPage = 1;
      this.pid = "";
      this.getKnowledgeScourceList("1");
    } else {
      this.pagination.currentPage = 1;
      this.getKnowledgeScourceList("0");
    }
  }
  // 清空
  handleClear() {}
  private handleCurrentChange(page: any) {
    this.pagination.currentPage = page;
    if (this.clickType === 1) {
      this.getKnowledgeDraftsList();
    } else if (this.clickType === 2) {
      this.getKnowledgeRecycleListList();
    } else if (this.clickType === 3) {
      this.pid = "";
      this.getKnowledgeScourceList("1");
    } else {
      this.getKnowledgeScourceList("0");
    }
  }
  private handlePageSizeChange(size: any) {
    this.pagination.pageSize = size;
    if (this.clickType === 1) {
      this.getKnowledgeDraftsList();
    } else if (this.clickType === 2) {
      this.getKnowledgeRecycleListList();
    } else if (this.clickType === 3) {
      this.pid = "";
      this.getKnowledgeScourceList("1");
    } else {
      this.getKnowledgeScourceList("0");
    }
  }

  private clickFile(row: any) {
    if (this.clickType === 0) {
      this.expandData = row;
    }
    if (parseInt(row.type) === 0) {
      this.pagination.currentPage = 1;
      this.pid = row.id;
      if (this.clickType === 2) {
        this.getKnowledgeRecycleListList();
      } else {
        this.getKnowledgeScourceList("0");
      }
    }
  }

  private addHandle(row: any) {
    this.$prompt("名称", "群组名称", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputPlaceholder: "请输入群组名称",
      inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{1,30}$/,
      inputErrorMessage: "请输入1-30位由数字、字母、中文组成的名称",
      inputValue: "",
    })
      .then(({ value }: any) => {
        let params: any = {
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName,
          company_id: UserModule.getCompanyId,
          pid: row && row.id ? row.id : this.pid,
          name: value,
        };
        addGroup(params).then((res: any) => {
          this.showSecussMsg(res.msg);
          this.getKnowledgeScourceList("0");
          this.refData = {
            id: row && row.id ? row.id : this.pid,
            isr: !this.refData.isr,
          };
        });
      })
      .catch(() => {});
  }
  private editorHandle(row: any) {
    this.$router.push({
      path: "add",
      query: {
        pid: row.pid,
        id: row.id,
      },
    });
  }
  private renameHandle(row: any) {
    this.$prompt("名称", "群组名称", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputPlaceholder: "请输入群组名称",
      inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{1,30}$/,
      inputErrorMessage: "请输入1-30位由数字、字母、中文组成的名称",
      inputValue: row.name,
    })
      .then(({ value }: any) => {
        let params: any = {
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName,
          company_id: UserModule.getCompanyId,
          id: row.id,
          name: value,
        };
        renameResources(params)
          .then((res: any) => {
            this.showSecussMsg(res.msg);
            this.getKnowledgeScourceList("0");
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }
  private starHandle(row: any) {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      id: row.id,
    };
    addCollection(params)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        this.getKnowledgeScourceList("0");
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private cancleHandle(row: any) {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      id: row.id,
    };
    delCollection(params)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        if (this.clickType === 3) {
          this.pagination.currentPage = 1;
          this.pid = "";
          this.getKnowledgeScourceList("1");
        } else {
          this.getKnowledgeScourceList("0");
        }
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private reSettingHandle(row: any) {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      id: row.id,
    };
    recover(params)
      .then((res: any) => {
        this.showSecussMsg(res.msg);
        this.getKnowledgeRecycleListList();
      })
      .catch((err) => {
        this.showErrorMsg(err.msg);
      });
  }
  private deleteHandle(row: any) {
    let params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      id: row.id,
    };
    if (this.clickType === 2) {
      reallyDelete(params)
        .then((res: any) => {
          this.showSecussMsg(res.msg);
          this.pagination.currentPage = 1;
          this.getKnowledgeRecycleListList();
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    } else if (this.clickType === 1) {
      delDocument(params)
        .then((res: any) => {
          this.showSecussMsg(res.msg);
          this.pagination.currentPage = 1;
          this.getKnowledgeDraftsList();
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    } else {
      delScource(params)
        .then((res: any) => {
          this.showSecussMsg(res.msg);
          if (this.clickType === 3) {
            this.pagination.currentPage = 1;
            this.pid = "";
            this.getKnowledgeScourceList("1");
          } else {
            if (parseInt(row.type) === 0) {
              this.refData = {
                id: row && row.pid ? row.pid : "0",
                isr: !this.refData.isr,
              };
            }
            this.getKnowledgeScourceList("0");
          }
        })
        .catch((err) => {
          this.showErrorMsg(err.msg);
        });
    }
  }

  private detailsHandle(val: any) {
    if (parseInt(val.type) === 99) {
      this.$router.push({
        path: "details",
        query: val,
      });
    } else {
      if (
        parseInt(val.type) === 5 ||
        parseInt(val.type) === 7 ||
        parseInt(val.type) === 6 ||
        parseInt(val.type) === 90
      ) {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", val.full_path, true);
        xhr.responseType = "blob";
        xhr.onload = function() {
          if (this.status === 200) {
            const blob = new Blob([this.response]);
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = val.name;
            a.click();
            window.URL.revokeObjectURL(blobUrl);
          }
        };
        xhr.send();
      } else {
        window.open(val.full_path);
      }
    }
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: "notification-center",
      type: "success",
    });
  }
}
